/**
 * Verificador de Proxy
 * Verifica se o usuário está usando proxy ou VPN
 */

var ProxyChecker = {
    // APIs para verificação de proxy
    proxyAPIs: [
        {
            name: "proxycheck.io",
            url: "https://proxycheck.io/v2/",
            timeout: 5000
        },
        {
            name: "zend-apps",
            url: "https://proxycheck.zend-apps.com/",
            timeout: 3000
        },
        {
            name: "ipqualityscore",
            url: "https://ipqualityscore.com/api/json/ip/",
            timeout: 5000
        }
    ],
    
    // Cache de verificações
    cache: new Map(),
    cacheTimeout: 300000, // 5 minutos
    
    /**
     * Verificar se um IP está usando proxy
     * @param {string} ip - Endereço IP para verificar
     * @param {function} callback - Função de callback
     */
    checkProxy: function(ip, callback) {
        // Verificar cache primeiro
        if (this.cache.has(ip)) {
            var cached = this.cache.get(ip);
            if (Date.now() - cached.timestamp < this.cacheTimeout) {
                callback(cached.result);
                return;
            }
        }
        
        // Verificar usando múltiplas APIs
        this.checkMultipleAPIs(ip, callback);
    },
    
    /**
     * Verificar usando múltiplas APIs
     * @param {string} ip - Endereço IP
     * @param {function} callback - Função de callback
     */
    checkMultipleAPIs: function(ip, callback) {
        var completed = 0;
        var results = [];
        var totalAPIs = this.proxyAPIs.length;
        
        this.proxyAPIs.forEach(function(api, index) {
            ProxyChecker.checkSingleAPI(api, ip, function(result) {
                results[index] = result;
                completed++;
                
                if (completed === totalAPIs) {
                    var finalResult = ProxyChecker.processResults(results);
                    ProxyChecker.cache.set(ip, {
                        result: finalResult,
                        timestamp: Date.now()
                    });
                    callback(finalResult);
                }
            });
        });
    },
    
    /**
     * Verificar usando uma única API
     * @param {object} api - Configuração da API
     * @param {string} ip - Endereço IP
     * @param {function} callback - Função de callback
     */
    checkSingleAPI: function(api, ip, callback) {
        var xhr = new XMLHttpRequest();
        var timeout = setTimeout(function() {
            xhr.abort();
            callback({ isProxy: false, confidence: 0, source: api.name, error: "timeout" });
        }, api.timeout);
        
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                clearTimeout(timeout);
                if (xhr.status === 200) {
                    try {
                        var data = JSON.parse(xhr.responseText);
                        var result = ProxyChecker.parseAPIResponse(data, api.name);
                        callback(result);
                    } catch (e) {
                        callback({ isProxy: false, confidence: 0, source: api.name, error: "parse_error" });
                    }
                } else {
                    callback({ isProxy: false, confidence: 0, source: api.name, error: "http_error" });
                }
            }
        };
        
        xhr.open("GET", api.url + ip + ".js", true);
        xhr.send();
    },
    
    /**
     * Processar resposta da API
     * @param {object} data - Dados da resposta
     * @param {string} source - Nome da fonte
     * @returns {object} Resultado processado
     */
    parseAPIResponse: function(data, source) {
        var result = {
            isProxy: false,
            confidence: 0,
            source: source,
            type: null,
            country: null,
            error: null
        };
        
        try {
            switch (source) {
                case "proxycheck.io":
                    if (data[Object.keys(data)[0]]) {
                        var ipData = data[Object.keys(data)[0]];
                        result.isProxy = ipData.proxy === "yes";
                        result.confidence = ipData.confidence || 0;
                        result.type = ipData.type || null;
                        result.country = ipData.country || null;
                    }
                    break;
                    
                case "zend-apps":
                    if (data[Object.keys(data)[0]]) {
                        var ipData = data[Object.keys(data)[0]];
                        result.isProxy = ipData.proxy === "yes";
                        result.confidence = 100; // Assumir alta confiança se retornou "yes"
                    }
                    break;
                    
                case "ipqualityscore":
                    result.isProxy = data.proxy === true;
                    result.confidence = data.fraud_score || 0;
                    result.type = data.proxy_type || null;
                    result.country = data.country_code || null;
                    break;
            }
        } catch (e) {
            result.error = "parse_error";
        }
        
        return result;
    },
    
    /**
     * Processar resultados de múltiplas APIs
     * @param {array} results - Array de resultados
     * @returns {object} Resultado final
     */
    processResults: function(results) {
        var validResults = results.filter(function(r) { return !r.error; });
        
        if (validResults.length === 0) {
            return { isProxy: false, confidence: 0, source: "none", error: "all_failed" };
        }
        
        // Calcular média de confiança
        var totalConfidence = 0;
        var proxyCount = 0;
        var totalCount = validResults.length;
        
        validResults.forEach(function(result) {
            totalConfidence += result.confidence;
            if (result.isProxy) {
                proxyCount++;
            }
        });
        
        var avgConfidence = totalConfidence / totalCount;
        var proxyRatio = proxyCount / totalCount;
        
        // Considerar proxy se mais de 50% das APIs detectaram ou confiança média > 50
        var isProxy = proxyRatio > 0.5 || avgConfidence > 50;
        
        return {
            isProxy: isProxy,
            confidence: Math.round(avgConfidence),
            source: "multiple",
            proxyCount: proxyCount,
            totalCount: totalCount,
            proxyRatio: Math.round(proxyRatio * 100)
        };
    },
    
    /**
     * Verificar se o usuário atual está usando proxy
     * @param {function} callback - Função de callback
     */
    checkCurrentUser: function(callback) {
        // Primeiro obter o IP do usuário
        this.getCurrentIP(function(ip) {
            if (ip) {
                this.checkProxy(ip, callback);
            } else {
                callback({ isProxy: false, confidence: 0, source: "none", error: "no_ip" });
            }
        }.bind(this));
    },
    
    /**
     * Obter IP atual do usuário
     * @param {function} callback - Função de callback
     */
    getCurrentIP: function(callback) {
        var apis = [
            "https://api.ipify.org?format=json",
            "https://ipapi.co/json/",
            "https://ipinfo.io/json"
        ];
        
        var completed = 0;
        var result = null;
        
        apis.forEach(function(api) {
            fetch(api)
                .then(function(response) { return response.json(); })
                .then(function(data) {
                    if (!result && data && data.ip) {
                        result = data.ip;
                    }
                    completed++;
                    if (completed === apis.length) {
                        callback(result);
                    }
                })
                .catch(function(error) {
                    completed++;
                    if (completed === apis.length && !result) {
                        callback(null);
                    }
                });
        });
    },
    
    /**
     * Limpar cache
     */
    clearCache: function() {
        this.cache.clear();
    },
    
    /**
     * Obter estatísticas do cache
     * @returns {object} Estatísticas do cache
     */
    getCacheStats: function() {
        return {
            size: this.cache.size,
            entries: Array.from(this.cache.entries())
        };
    }
};

// Exportar para uso global
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ProxyChecker;
} else if (typeof window !== 'undefined') {
    window.ProxyChecker = ProxyChecker;
}

